import React from "react";
import { typeSidebarData } from "../constants";
import { ViewComponent } from "./ViewComponent";

export type typeSidebarMenu = {
  data: typeSidebarData;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const SidebarMenu: React.FC<typeSidebarMenu> = ({ data, onClick }) => {
  return <ViewComponent data={data} onClick={onClick} />;
};
